export default __webpack_public_path__ + "static/property-img-1_768-8fa801f792c99fb56243b232e6cb025e.jpg";